<template>
  <div class="required props-group">
    <el-form-item label="必填">
      <el-checkbox v-model="component.properties.required"></el-checkbox>
    </el-form-item>
  </div>
</template>

<script>
export default {
  name: 'attr-required',
  props: ['component'],
  watch: {
    'component.properties.readonly' (val) {
      if (val) {
        this.component.properties.required = false
      }
    }
  }
}
</script>

<style>
  .required{
    border-top: 1px solid #ebebeb;
  }
</style>



// WEBPACK FOOTER //
// src/components/form/componentAttr/required.vue